var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAddCampaignFormContext } from 'root/src/client/v2/_pages/add-campaign/contexts/addCampaignForm.context';
import { useAddCampaignFormSubmits } from 'root/src/client/v2/_pages/add-campaign/hooks/useAddCampaignFormSubmits';
import toast from 'react-hot-toast';
import { useIsMutating } from '@tanstack/react-query';
import { SAVE_DROP_EVENT_MUTATION_KEY } from 'root/src/client/v2/drop/hooks/useDropEvent';
const AUTO_SAVE_TOAST_DURATION = 2000;
export const useAutoSave = () => {
    const form = useAddCampaignFormContext();
    const { onSubmit } = useAddCampaignFormSubmits();
    const isSaving = Boolean(useIsMutating({
        mutationKey: SAVE_DROP_EVENT_MUTATION_KEY,
    }));
    const autoSave = () => __awaiter(void 0, void 0, void 0, function* () {
        const shouldAutoSave = form.formState.isDirty && !isSaving;
        if (!shouldAutoSave) {
            return;
        }
        form.reset({}, {
            keepValues: true,
            keepDefaultValues: true,
            keepDirty: false,
        });
        toast.loading('Saving...', {
            position: 'bottom-left',
            duration: AUTO_SAVE_TOAST_DURATION,
            style: {
                backgroundColor: 'var(--dark-2)',
                color: 'var(--light-3)',
                fontSize: '.85rem',
            },
        });
        yield onSubmit();
    });
    return { autoSave };
};
